module.exports = __webpack_public_path__ + "static/media/owner.51fa9039.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/owner.png
// module id = 585
// module chunks = 0